import { DateFormat } from 'constants/DateFormat';
import dayjs from 'utils/dayjs';
import { useContext, useMemo } from 'react';
import { AvailabilitiesContext } from '../Availabilities';
import AvailabilitiesCalendarHeader from './header';
import AvailabilitiesCalendarRow from './row';
import { AvailabilitiesCalendarBody, AvailabilitiesCalendarContainer } from './styles';

const AvailabilitiesCalendar = (): JSX.Element => {
  const { currentMonth, currentYear } = useContext(AvailabilitiesContext);

  const currentMonthMoment = dayjs().month(currentMonth).year(currentYear);
  const firstDayOfMonth = currentMonthMoment.clone().startOf('month').startOf('week');
  const lastDayOfMonth = currentMonthMoment.clone().endOf('month');

  const mondaysOfTheMonth = useMemo(() => {
    const mondays = [firstDayOfMonth];
    for (let i = 1; i < 5; i++) {
      mondays.push(firstDayOfMonth.clone().add(i, 'weeks'));
    }
    if (mondays[4].clone().add(1, 'weeks').isSameOrBefore(lastDayOfMonth)) {
      mondays.push(firstDayOfMonth.clone().add(5, 'weeks'));
    }
    return mondays;
  }, [firstDayOfMonth, lastDayOfMonth]);

  const sixRowsCalendar = useMemo(() => {
    return mondaysOfTheMonth.length === 6;
  }, [mondaysOfTheMonth]);

  return (
    <AvailabilitiesCalendarContainer>
      <AvailabilitiesCalendarHeader />
      <AvailabilitiesCalendarBody>
        {mondaysOfTheMonth.map(monday => (
          <AvailabilitiesCalendarRow
            firstDayOfWeek={monday}
            key={monday.format(DateFormat.FULL_DATE)}
            sixRowsCalendar={sixRowsCalendar}
          />
        ))}
      </AvailabilitiesCalendarBody>
    </AvailabilitiesCalendarContainer>
  );
};

export default AvailabilitiesCalendar;
